// Omertàbella — single source of truth for the brand lockup.
// Wordmark is one word ("Omertàbella") with the accent on the à. No space.
// Tracking restored to the original 0.45em (hero) / 0.30em (header).

import monoTransparent from "../../assets/brand/logo_monogram_canonical.png";

const COMMON_TEXT = "select-none";
const MONO_FILTER = "drop-shadow(0 0 1px rgba(245,240,232,0.5)) drop-shadow(0 0 8px rgba(201,168,76,0.15))";

function Monogram({ height, alt = "Omertàbella", className = "" }) {
  return (
    <img
      src={monoTransparent}
      alt={alt}
      loading="eager"
      decoding="async"
      draggable={false}
      className={`block w-auto ${COMMON_TEXT} ${className}`}
      style={{ height, filter: MONO_FILTER }}
    />
  );
}

export function LogoLockup({ variant = "hero", className = "", as: As = "div", glow = false, ...rest }) {
  if (variant === "hero") {
    return (
      <As className={`relative flex flex-col items-center ${className}`} {...rest}>
        {glow && (
          <span
            aria-hidden
            className="pointer-events-none absolute left-1/2 top-[120px] -z-10 -translate-x-1/2 rounded-full"
            style={{
              width: 520, height: 520,
              background: "radial-gradient(circle, rgba(201,168,76,0.18) 0%, rgba(201,168,76,0.06) 35%, transparent 70%)",
              filter: "blur(40px)",
            }}
          />
        )}
        <Monogram height="clamp(120px, 22vw, 280px)" />
        <p
          className={`mt-6 whitespace-nowrap text-center font-display font-normal text-brand-text ${COMMON_TEXT}`}
          style={{ letterSpacing: "0.45em", textTransform: "uppercase", fontSize: "clamp(20px, 4vw, 56px)", lineHeight: 1 }}
        >
          Omertàbella
        </p>
        <p
          className={`mt-[18px] whitespace-nowrap text-center ${COMMON_TEXT}`}
          style={{
            fontFamily: "Inter, system-ui, sans-serif",
            fontWeight: 400,
            textTransform: "uppercase",
            letterSpacing: "0.28em",
            color: "rgba(245, 240, 232, 0.85)",
            fontSize: "clamp(10px, 1vw, 14px)",
          }}
        >
          Private Influence. Public Power.
        </p>
      </As>
    );
  }

  if (variant === "login") {
    return (
      <As className={`relative flex w-full max-w-full flex-col items-center ${className}`} {...rest}>
        {glow && (
          <span
            aria-hidden
            className="pointer-events-none absolute left-1/2 top-[60px] -z-10 -translate-x-1/2 rounded-full"
            style={{
              width: 420, height: 420,
              background: "radial-gradient(circle, rgba(201,168,76,0.18) 0%, rgba(201,168,76,0.05) 40%, transparent 75%)",
              filter: "blur(50px)",
            }}
          />
        )}
        <Monogram height="clamp(96px, 18vw, 200px)" />
        <p
          className={`mt-5 text-center font-display font-normal text-brand-text ${COMMON_TEXT}`}
          style={{ letterSpacing: "0.3em", textTransform: "uppercase", fontSize: "clamp(15px, 2.6vw, 36px)", lineHeight: 1.1 }}
        >
          Omertàbella
        </p>
        <p
          className={`mt-[14px] text-center ${COMMON_TEXT}`}
          style={{
            fontFamily: "Inter, system-ui, sans-serif", fontWeight: 400,
            textTransform: "uppercase", letterSpacing: "0.18em",
            color: "rgba(245, 240, 232, 0.78)", fontSize: "clamp(8px, 0.85vw, 12px)",
          }}
        >
          Private Influence. Public Power.
        </p>
      </As>
    );
  }

  if (variant === "header") {
    return (
      <As className={`inline-flex items-center gap-3 ${className}`} {...rest}>
        <Monogram height="48px" />
        <span
          className={`font-display font-normal text-brand-text ${COMMON_TEXT}`}
          style={{ fontSize: "17px", letterSpacing: "0.30em", textTransform: "uppercase", whiteSpace: "nowrap" }}
        >
          Omertàbella
        </span>
      </As>
    );
  }

  if (variant === "footer") {
    return (
      <As className={`inline-flex items-center gap-3 ${className}`} {...rest}>
        <Monogram height="48px" />
        <span
          className={`font-display font-normal text-brand-text/85 ${COMMON_TEXT}`}
          style={{ fontSize: "14px", letterSpacing: "0.30em", textTransform: "uppercase", whiteSpace: "nowrap" }}
        >
          Omertàbella
        </span>
      </As>
    );
  }

  return null;
}
